/**
 * IMPORT CORE DI ANGULAR
 */

import { NgModule } from '@angular/core';

import { MainHomeComponent } from './home/home.component';
import { MainComponent } from './main.component';
import { SharedModule } from '../shared/shared.module';
import { Routes, RouterModule } from '@angular/router';
import { HomepageResolver } from '../shared/_resolver/homepage.resolver';
import { InstallatoriResolver } from '../shared/_resolver/installatori.resolver';
import { MainResolver } from '../shared/_resolver/main.resolver';
import { TranslateModule } from '@ngx-translate/core';
import { MetaGuard } from '@ngx-meta/core';
import { LocalizeRouterModule } from 'localize-router';
import { PaginaNonTrovataComponent } from './pagina-non-trovata/pagina-non-trovata.component';
import { PagamentoAnnullatoComponent } from './carrello/pagamento-annullato/pagamento-annullato.component';
import { RegistrazioneComponent } from './registrazione/registrazione.component';
import { CardListConfiguratoreComponent } from './card-list-configuratore/card-list-configuratore.component';
import { GradinatoreResolver } from '../shared/_resolver/gradinatore.resolver';
import { LoginComponent } from '../shared/_component/login/login.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { RicercaGenericaComponent } from './ricerca-generica/ricerca-generica.component';
import { InstallatoriComponent } from './installatori/installatori.component';
import { ContattiComponent } from './contatti/contatti.component';

const routes: Routes = [
  {
    path: '',
    canActivateChild: [MetaGuard],
    component: MainComponent,
    resolve: { MainResolver },
    children: [
      {
        path: '',
        component: MainHomeComponent,
        resolve: { HomepageResolver }
      },
      {
        path: '404',
        component: PaginaNonTrovataComponent,
      },
      {
        path: 'carrello/pagamento-annullato',
        component: PagamentoAnnullatoComponent,
      },
      {
        path: 'registrazione',
        component: RegistrazioneComponent,
      },
      {
        path: 'reset-password',
        component: ResetPasswordComponent
      },
      {
        path: 'ricerca-generica',
        component: RicercaGenericaComponent
      },
      {
        path: 'login',
        component: LoginComponent,
      },
      {
        path: 'installatori',
        component: InstallatoriComponent,
        resolve: { InstallatoriResolver }
      },
      {
        path: 'contatti',
        component: ContattiComponent,
      },
      {
        path: 'configuratore',
        component: CardListConfiguratoreComponent,
        resolve: { GradinatoreResolver }
      },
      {
        path: 'area-riservata',
        loadChildren: () => import('./area-riservata/area-riservata.module').then(m => m.AreaRiservataModule),
      },
      {
        path: 'carrello',
        loadChildren: () => import('./carrello/carrello.module').then(m => m.CarrelloModule),
      },
      {
        path: 'informazioni',
        loadChildren: () => import('./informazioni/informazioni.module').then(m => m.InformazioniModule),
      },
      {
        path: ':categoriaScheda',
        loadChildren: () => import('./dynamic-schede/dynamic-schede.module').then(m => m.DynamicSchedeModule),
      }
    ]
  }
];

@NgModule({
  declarations: [
    MainComponent,
    MainHomeComponent,
    PagamentoAnnullatoComponent,
    RegistrazioneComponent,
    CardListConfiguratoreComponent,
    ContattiComponent,
    ResetPasswordComponent,
    RicercaGenericaComponent,
    InstallatoriComponent
  ],
  imports: [
    TranslateModule.forChild(),
    SharedModule,
    RouterModule.forChild(routes),
    LocalizeRouterModule.forChild(routes),
  ],
  exports: [],
  providers: []
})
export class MainModule { }
